'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LinkIcon = ({ sx, className }) => {
  return (
    <SvgIcon sx={sx} data-testid="LinkIcon">
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_2120_17841)">
          <path
            d="M4.89755 2.68726H1.22255C0.816599 2.68726 0.487549 3.01636 0.487549 3.42226V10.7723C0.487549 11.1782 0.816599 11.5073 1.22255 11.5073H8.57255C8.97845 11.5073 9.30755 11.1782 9.30755 10.7723V7.11931"
            stroke={sx?.color || '#3D517B8F'}
            strokeWidth="0.580853"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.69263 9.31268L11.5126 0.492676"
            stroke={sx?.color || '#3D517B8F'}
            strokeWidth="0.580853"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.10254 0.492676H11.5125V4.90268"
            stroke={sx?.color || '#3D517B8F'}
            strokeWidth="0.580853"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

LinkIcon.propTypes = {
  sx: PropTypes.object,
  className: PropTypes.string
}
